import { Button, Grid, Typography } from "@mui/material";
import { InfoCard } from "./InfoCard";
import Images from "../UserModal/Images";
import { IAttempt } from "../../types/images";
import { InactivityAlert, InactivityModal } from "./InactivityModal";
import { useActivity } from "./hooks";
import { Controls } from "./Controls";

interface LattestAttepltProps {
  attempt: IAttempt;
  setFullScreen(screen: boolean): void;
  setAttemptIndex(attempt: number): void;
}

export function LatestAttempt(props: LattestAttepltProps) {
  const { attempt, setFullScreen, setAttemptIndex } = props;
  const height = window.screen.height;

  const { isModalOpen, countdown, handleStaySignedIn, restartQueue } = useActivity(5);

  const imgSize = attempt.images.selfieRef || attempt.images.document ? 6 : 12;

  return (
    <Grid container spacing={2} sx={{}}>
      <InactivityAlert open={isModalOpen} />
      <InactivityModal
        open={isModalOpen}
        handleClose={handleStaySignedIn}
        handleResetQueue={restartQueue}
        countdown={countdown}
      />
      <Grid item xs={9} xl={9} sx={{}}>
        <Typography variant={"h3"}>
          {attempt.info.Verification_Type
            ? "Authentication - Compare selfie to selfie"
            : "Registration - Compare selfie to document"}
        </Typography>
        <Button
          onClick={() => {
            setFullScreen(true);
            setAttemptIndex(0);
          }}
        >
          FullScreen
        </Button>
        <Images
          imgHeight={height * 0.5}
          images={attempt.images}
          imgSize={imgSize}
          imgControl={false}
          // showContraols={'none'}
        />
      </Grid>
      <Grid item xs={3} xl={3}>
        <InfoCard info={attempt.info} />
        <Controls />
      </Grid>
    </Grid>
  );
}
